import { render } from "./ProNoteRequestStatus.vue?vue&type=template&id=98bf7e30"
import script from "./ProNoteRequestStatus.vue?vue&type=script&lang=js"
export * from "./ProNoteRequestStatus.vue?vue&type=script&lang=js"

import "./ProNoteRequestStatus.vue?vue&type=style&index=0&id=98bf7e30&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__